import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallback from "../../../components/blocks/ErrorBoundaryFallback/ErrorBoundaryFallback";
import { handleErrorBoundaryError } from "../../../lib/error-boundary/handle-error-boundary-error";

export function withRouteErrorBoundary(element: JSX.Element): JSX.Element {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback} onError={handleErrorBoundaryError}>
      {element}
    </ErrorBoundary>
  );
}
